/** Field names are the API's, not local shorthand. They were `from`/`to` once:
 *  that is structurally assignable to the compare request type (whose date
 *  fields are optional), so it typechecked, silently sent no window, and both
 *  periods came back as the whole book with a 0.0% change. Keeping the wire
 *  names here is what makes the mismatch impossible. */
export type QuarterSpec = { label: string; dateFrom: string; dateTo: string }

/** Quarter boundaries for the last three years, newest first — the periods
 *  people actually compare. Derived from the current date rather than
 *  hard-coded so it stays correct next year. */
export function quarters(reference: Date, years = 3): QuarterSpec[] {
  const out: QuarterSpec[] = []
  for (let y = reference.getUTCFullYear(); y > reference.getUTCFullYear() - years; y -= 1) {
    for (let q = 4; q >= 1; q -= 1) {
      const startMonth = (q - 1) * 3
      const start = new Date(Date.UTC(y, startMonth, 1))
      if (start > reference) continue
      const end = new Date(Date.UTC(y, startMonth + 3, 0))
      out.push({
        label: `Q${q} ${y}`,
        dateFrom: start.toISOString().slice(0, 10),
        dateTo: end.toISOString().slice(0, 10),
      })
    }
  }
  return out
}
